import { useState } from 'react';

import { Checkbox, FormControlLabel, Typography } from '@material-ui/core';

import * as utils from 'utils';
import { useQuoteCardStyles } from './QuoteCard.styles';
import { usePatchExternallyReferredQuote } from 'lib/quoteBind';

export const ExternallyReferredOption = ({ quote }) => {
  const classes = useQuoteCardStyles();

  const [isLoading, setIsLoading] = useState(false);

  const { mutateAsync: patchExternallyReferred } = usePatchExternallyReferredQuote();

  const handleChange = async (_, checked) => {
    setIsLoading(true);
    try {
      await patchExternallyReferred({
        quote,
        value: checked,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <FormControlLabel
      sx={{
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      label={
        <Typography
          variant="body2"
          className={classes.value}
        >
          {utils.string.t('risks.externallyReferred')}
        </Typography>
      }
      control={
        <Checkbox
          color="primary"
          checked={!!quote?.externalReferral}
          disabled={isLoading}
          onChange={handleChange}
        />
      }
    />
  );
};
